<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Администраторы</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <CDataTable
                            hover
                            striped
                            column-filter
                            sorter
                            :items="items"
                            :fields="fields"
                            :items-per-page="10"
                            clickable-rows
                            :active-page="activePage"
                            :pagination="{ doubleArrows: true, align: 'center'}"
                            @row-clicked="rowClicked"
                            @page-change="pageChange"
                        >
                            <template #enabled="data">
                                <td>
                                    <CBadge :color="getBadge(data.item.enabled)">
                                        &nbsp;{{ data.item.enabled ? 'Да' : 'Нет' }}&nbsp;
                                    </CBadge>
                                </td>
                            </template>
                        </CDataTable>
                    </template>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="showCreateModal">Создать</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Создание администратора"
            :show.sync="createModal.show"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Имя
                            </CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createModal.name"
                                    placeholder="Введите имя администратора"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Email
                            </CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createModal.email"
                                    placeholder="Адрес электронной почты"
                                    autocomplete="new-password"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="light"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="createModal.enabled"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Пароль
                            </CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createModal.password"
                                    placeholder="Введите пароль"
                                    type="password"
                                    autocomplete="new-password"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Подтверждение
                            </CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createModal.password2"
                                    placeholder="Введите пароль еще раз"
                                    type="password"
                                    autocomplete="new-password"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createModal.show = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createAdmin">Создать</CButton>
                </div>
            </template>
        </CModal>

    </CRow>
</template>

<script>
    import Vue from 'vue';

    export default {

        name: 'Administrators',
  
        data () {
            return {
                loading: true,
                items: [],
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'name', label: 'Имя' },
                    { key: 'email', label: 'Email' },
                    { key: 'enabled', label: 'Активен' }
                ],
                activePage: 1,
                createModal: {
                    show: false,
                    name: '',
                    email: '',
                    active: '',
                    password: '',
                    password2: ''
                }
            }
        },

        async mounted() {
            await Vue.axios.get('/administrators')
                .then(resp => {
                    this.items = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            this.loading = false;
        },
    
        watch: {
            $route: {
                immediate: true,
                handler (route) {
                    if (route.query && route.query.page) {
                        this.activePage = Number(route.query.page)
                    }
                }
            }
        },

        methods: {
            createAdmin() {
                if(!this.createModal.name) {
                    this.$root.$emit('showError', 'Имя администратора не может быть пустым.');
                    return;
                }
                if(!this.createModal.email) {
                    this.$root.$emit('showError', 'Email администратора не может быть пустым.');
                    return;
                }
                if(!this.createModal.password || !this.createModal.password2) {
                    this.$root.$emit('showError', 'Введите пароль и подтверждение.');
                    return;
                }
                if(this.createModal.password !== this.createModal.password2) {
                    this.$root.$emit('showError', 'Пароли должны совпадать.');
                    return;
                }
                if(this.createModal.password.length < 6) {
                    this.$root.$emit('showError', 'Пароль должен быть не менее 6 символов.');
                    return;
                }
                Vue.axios.post('/administrators/create', {
                    name: this.createModal.name,
                    email: this.createModal.email,
                    enabled: this.createModal.enabled,
                    password: this.createModal.password
                })
                    .then(resp => {
                        this.createModal.name = this.createModal.email = '';
                        this.createModal.enabled = false;
                        this.createModal.password = this.createModal.password2 = '';
                        this.createModal.show = false;
                        location.reload();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка создания администратора.');
                    });
            },
            showCreateModal() {
                this.createModal.name = this.createModal.email = this.createModal.active = '';
                this.createModal.password = this.createModal.password2 = '';
                this.createModal.show = true;
            },
            getBadge (status) {
                return status ? 'success' : 'secondary';
            },
            rowClicked (item, index) {
                this.$router.push({ path: `administrators/${item.id}` })
            },
            pageChange (val) {
                this.$router.push({ query: { page: val } })
            }
        }
    }
</script>
